import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { AgentImpersonationStatus, PropallyAgentV1Api } from "../api/generated/src";
import { ImpersonationState, ImpersonationStateType } from "../view_models/atoms";

const fetchImpersonation = async (): Promise<AgentImpersonationStatus> => {
  return new Promise((resolve, reject) => {
    new PropallyAgentV1Api().agentV1ImpersonationGet(
      (error: object, data: AgentImpersonationStatus, response: object) => {
        if (error) {
          reject(error);
        } else {
          resolve(data);
        }
      }
    );
  });
};

// AuthProvider の再検証に相乗りさせていないのは、あちらが保護ページの遷移ごとに走るため。
// 代理ログインかどうかは同一セッション中に変わらないので、1回取れば足りる。
//
// 取得に失敗したときは active: false に倒す。AIオファーの導線が出ないだけで、
// 従来の送信は動く。
export const useImpersonation = (): ImpersonationStateType => {
  const [impersonation, setImpersonation] = useRecoilState(ImpersonationState);

  useEffect(() => {
    if (impersonation.loaded) {
      return;
    }

    let mounted = true;
    fetchImpersonation()
      .then((data) => {
        if (mounted) {
          setImpersonation({ active: data.active === true, loaded: true, readOnly: data.read_only === true });
        }
      })
      .catch(() => {
        if (mounted) {
          setImpersonation({ active: false, loaded: true, readOnly: false });
        }
      });

    return () => {
      mounted = false;
    };
  }, [impersonation.loaded, setImpersonation]);

  return impersonation;
};
